import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from './service';

export default class CategoryService extends Service {
  async get(lat?: number, lng?: number, type?: string) {
    let root = this.root;

    if (lat === null || lng === null) {
      lat = 45.461487;
      lng = 9.189327;
    }

    const stringified = `?latitude=${lat}&longitude=${lng}&type=${(
      type || ''
    ).toLowerCase()}`;

    return await doRequest({
      auth: false,
      method: HttpMethodEnum.GET,
      url: `${root}v2/categories/${stringified}`,
    });
  }
}
